import React from "react";
import Today from "./Today";
export default function ThisWeek() {
  return (
    <>
      <div>
        <Today />{" "}
      </div>
    </>
  );
}
